(function () {
  'use strict';
  var core = window.lnwFocalCore;
  if (!core) return;
  var cache = new Map(), cardCache = new Map(), initialVersion = 0;
  function thai(url) { return /\/th(?:-[a-z]+)?\//i.test(url.pathname); }
  function copy(url) { return new URL(url.href); }
  // Treat equivalent query encodings (24,35 / 24%2C35, spaces / +) alike.
  // URLSearchParams mutations serialize the query even when no value changes.
  function key(url) { var query = url.searchParams.toString(); return url.pathname + (query ? '?' + query : ''); }
  function endpoint(url, view, page, unfiltered) {
    var result = copy(url);
    ['view', 'page', 'lnw_focal', 'lnw_focal_page', 'grid_list', 'section_id'].forEach(function (name) { result.searchParams.delete(name); });
    if (unfiltered) Array.from(result.searchParams.keys()).forEach(function (name) { if (name.indexOf('filter.') === 0) result.searchParams.delete(name); });
    result.searchParams.set('view', view);
    result.searchParams.set('page', String(page));
    return result;
  }
  async function json(url, schema, signal) {
    var response = await fetch(url.pathname + url.search, { credentials: 'same-origin', signal: signal });
    if (!response.ok) throw new Error('Focal data unavailable');
    var data = await response.json();
    if (data.schema !== schema || data.error || !Array.isArray(data.products)) throw new Error('Invalid focal data');
    return data;
  }
  async function parallel(items, work) {
    var result = new Array(items.length), index = 0;
    await Promise.all(Array.from({ length: Math.min(2, items.length) }, async function () {
      while (index < items.length) { var at = index++; result[at] = await work(items[at]); }
    }));
    return result;
  }
  function cached(store, cacheKey, loader, signal) {
    if (signal && signal.aborted) return Promise.reject(signal.reason);
    var entry = store.get(cacheKey);
    if (!entry || entry.controller.signal.aborted || Date.now() - entry.at >= 30000) {
      var controller = new AbortController();
      entry = { controller: controller, at: Date.now(), pending: true, users: 0 };
      var timer = setTimeout(function () { controller.abort(); }, 15000);
      entry.promise = loader(controller.signal).then(function (data) {
        clearTimeout(timer); entry.pending = false; entry.at = Date.now(); return data;
      }, function (error) {
        clearTimeout(timer); entry.pending = false;
        if (store.get(cacheKey) === entry) store.delete(cacheKey);
        throw error;
      });
      store.set(cacheKey, entry);
      if (store.size > 30) {
        for (var pair of store) { if (!pair[1].pending && pair[0] !== cacheKey) { store.delete(pair[0]); break; } }
      }
    }
    entry.users++;
    return new Promise(function (resolve, reject) {
      var settled = false;
      function finish(callback, value) {
        if (settled) return;
        settled = true; if (signal) signal.removeEventListener('abort', abort);
        entry.users--; if (entry.pending && !entry.users) entry.controller.abort();
        callback(value);
      }
      function abort() { finish(reject, signal.reason || new DOMException('Aborted', 'AbortError')); }
      if (signal) signal.addEventListener('abort', abort, { once: true });
      entry.promise.then(function (data) { finish(resolve, data); }, function (error) { finish(reject, error); });
    });
  }
  async function allProducts(url, unfiltered, signal) {
    var firstURL = endpoint(url, 'lnw-focal-data', 1, unfiltered), cacheKey = key(firstURL);
    return cached(cache, cacheKey, async function (requestSignal) {
      var first = await json(firstURL, 'lnw-focal-data-1', requestSignal), products = first.products;
      if (!Number.isInteger(first.pages) || first.pages < 0 || first.pages > 20) throw new Error('Focal pagination unavailable');
      var numbers = Array.from({ length: Math.max(0, first.pages - 1) }, function (_, i) { return i + 2; });
      var rest = await parallel(numbers, async function (page) {
        var data = await json(endpoint(url, 'lnw-focal-data', page, unfiltered), 'lnw-focal-data-1', requestSignal);
        if (data.total !== first.total || data.page !== page) throw new Error('Focal catalog changed during loading');
        return data.products;
      });
      rest.forEach(function (rows) { products = products.concat(rows); });
      if (products.length !== first.total || new Set(products.map(function (p) { return p.id; })).size !== products.length) throw new Error('Incomplete focal catalog');
      products.forEach(function (p) { p.optics = core.optics(p); });
      return products;
    }, signal);
  }
  function widgets(section, url, products) {
    var lengths = core.selected(url.searchParams), isThai = thai(url), signature = key(url);
    section.querySelectorAll('[data-lnw-focal-filter]').forEach(function (widget) {
      // Selected URLs are ready only after their cards and total are replaced.
      if (!lengths.length) widget.dataset.lnwFocalReady = signature;
      else delete widget.dataset.lnwFocalReady;
      widget.removeAttribute('aria-busy');
      if (lengths.length) widget.open = true;
      widget.querySelectorAll('[data-lnw-focal-value]').forEach(function (button) {
        var value = core.choiceValue(button.dataset.lnwFocalValue), active = lengths.indexOf(value) !== -1;
        var count = products.filter(function (p) { return core.matchesFocalsInContext(p, [value], url.searchParams); }).length;
        button.setAttribute('aria-checked', String(active));
        button.disabled = count === 0 && !active;
        button.querySelector('[data-lnw-focal-count]').textContent = String(count);
        button.setAttribute('aria-label', value + ' mm · ' + count + (isThai ? ' รายการ' : ' products'));
      });
      var message = widget.querySelector('[data-lnw-focal-message]');
      if (message) { message.hidden = true; message.textContent = ''; }
      var retry = widget.querySelector('[data-lnw-focal-retry]');
      if (retry) retry.hidden = true;
      var remove = widget.querySelector('[data-lnw-focal-remove-all]');
      if (remove) remove.hidden = true;
    });
    activeChips(section, url);
    nativeStates(section);
    resultCount(section, url, products.length);
    syncState(section, url);
  }
  function activeChips(section, url) {
    var host = section.querySelector('[data-lnw-focal-active]'), lengths = core.selected(url.searchParams);
    if (host) { host.replaceChildren(); host.hidden = true; }
    section.querySelectorAll('[data-lnw-selected-filters]').forEach(function (list) {
      list.querySelectorAll('[data-lnw-focal-item]').forEach(function (item) { item.remove(); });
      var label = list.querySelector('[data-lnw-selected-label]');
      var count = list.querySelectorAll('a[data-filter-input]').length + lengths.length;
      list.hidden = !count;
      if (label) { label.hidden = !count; label.textContent = (thai(url) ? 'เลือกแล้ว ' : 'Selected ') + count; }
      var clear = list.querySelector('.active-filter-group--remove-all');
      if (clear) clear.hidden = !count;
      lengths.slice().reverse().forEach(function (value) {
        var item = document.createElement('li'), button = document.createElement('button');
        item.dataset.lnwFocalItem = ''; button.type = 'button'; button.className = 'lnw-focal-chip'; button.dataset.lnwFocalRemove = String(value);
        button.appendChild(document.createTextNode(value + ' mm '));
        var icon = document.createElement('span'); icon.textContent = '×'; icon.setAttribute('aria-hidden', 'true'); button.appendChild(icon);
        button.setAttribute('aria-label', (thai(url) ? 'ล้างระยะเลนส์ ' : 'Remove focal length ') + value + ' mm');
        item.appendChild(button); if (label) label.insertAdjacentElement('afterend', item); else list.prepend(item);
      });
    });
  }
  function nativeStates(section) {
    section.querySelectorAll('[data-lnw-filter-param] a[data-value]').forEach(function (link) {
      var active = link.closest('.collection-filters__filter-list-item')?.classList.contains('collection-filters__filter-list-item--active');
      var disabled = link.hasAttribute('data-disabled') && !active;
      link.setAttribute('role', 'checkbox'); link.setAttribute('aria-checked', String(!!active));
      link.setAttribute('aria-disabled', String(disabled));
      if (disabled) link.setAttribute('tabindex', '-1'); else link.removeAttribute('tabindex');
    });
  }
  function resultCount(section, url, count) {
    var result = section.querySelector('[data-lnw-focal-result-count]');
    if (!result) return;
    result.hidden = false; result.dataset.lnwResultTotal = String(count); result.setAttribute('role', 'status'); result.setAttribute('aria-live', 'polite');
    result.textContent = (thai(url) ? 'พบ ' : '') + count + (thai(url) ? ' รายการ' : ' products');
  }
  function feedback(section, loading) {
    var result = section?.querySelector('[data-lnw-focal-result-count]');
    if (!result) return;
    var isThai = thai(new URL(location.href));
    if (loading) { result.hidden = false; result.textContent = isThai ? 'กำลังอัปเดตผลลัพธ์…' : 'Updating results…'; }
    document.querySelectorAll('.lnw-filter-done').forEach(function (button) {
      var count = result.dataset.lnwResultTotal;
      var text = loading ? (isThai ? 'กำลังอัปเดตผลลัพธ์…' : 'Updating results…') : count === undefined ? (isThai ? 'ดูสินค้า' : 'View products') : ((isThai ? 'ดูสินค้า ' : 'View ') + count + (isThai ? ' รายการ' : ' products'));
      if (button.textContent !== text) button.textContent = text;
    });
  }
  function syncState(section, url) {
    if (!section || !section.querySelector('[data-lnw-focal-filter]')) return;
    var widget = section.querySelector('[data-lnw-focal-filter]');
    var count = Number(widget.dataset.lnwNativeFilterCount || 0) + core.selected(url.searchParams).length;
    var label = (thai(url) ? 'ตัวกรอง' : 'Filters') + (count ? ' (' + count + ')' : '');
    section.querySelectorAll('[data-productgrid-trigger-filters]').forEach(function (button) {
      button.setAttribute('aria-label', label);
      var text = button.querySelector('.utils-filter-text');
      if (text) text.textContent = label;
    });
  }
  function refineCounts(section, url, all) {
    var lengths = core.selected(url.searchParams);
    section.querySelectorAll('[data-lnw-filter-param]').forEach(function (group) {
      var param = group.dataset.lnwFilterParam;
      if (!param || param === 'filter.v.price') return;
      var context = new URLSearchParams(url.searchParams); context.delete(param);
      var pool = all.filter(function (p) { return core.matchesFocalsInContext(p, lengths, context) && core.matchesNative(p, url.searchParams, param); });
      group.querySelectorAll('a[data-value]').forEach(function (link) {
        var value = link.dataset.value, params = new URLSearchParams(); params.append(param, value);
        var count = pool.filter(function (p) { return core.matchesNative(p, params); }).length;
        var pill = link.querySelector('.lnw-filter-count'); if (pill) pill.textContent = String(count);
        var row = link.closest('.collection-filters__filter-list-item'), active = row && row.classList.contains('collection-filters__filter-list-item--active');
        if (!count && !active) { link.setAttribute('data-disabled', ''); link.setAttribute('aria-disabled', 'true'); }
        else { link.removeAttribute('data-disabled'); link.removeAttribute('aria-disabled'); }
      });
    });
    nativeStates(section);
  }
  function region(section, url) {
    var grid = section.querySelector('[data-productgrid-items]');
    if (!grid) {
      var old = section.querySelector('.productgrid--no-results');
      if (!old) throw new Error('Missing focal result region');
      var config = JSON.parse(section.querySelector('[data-section-data]').textContent);
      grid = document.createElement('div'); grid.className = 'productgrid--items products-per-row-' + (config.lnw_products_per_row || '4');
      grid.dataset.productgridItems = ''; grid.dataset.html = 'productgrid-items'; old.replaceWith(grid);
    }
    section.querySelectorAll('.productgrid--no-results').forEach(function (node) { node.remove(); });
    section.querySelectorAll('.pagination--container').forEach(function (node) { node.remove(); });
    return grid;
  }
  async function cards(url, products, indices, signal) {
    var pages = Array.from(new Set(indices.map(function (i) { return Math.floor(i / 50) + 1; }))), result = new Map();
    var results = await parallel(pages, async function (page) {
      var cardURL = endpoint(url, 'lnw-focal-cards', page, false);
      var data = await cached(cardCache, key(cardURL), function (requestSignal) { return json(cardURL, 'lnw-focal-cards-1', requestSignal); }, signal);
      if (data.total !== products.length || data.page !== page) throw new Error('Focal cards changed during loading');
      return data.products;
    });
    results.forEach(function (rows) { rows.forEach(function (p) { result.set(p.id, p.html); }); });
    return result;
  }
  function pager(grid, url, page, pages) {
    if (pages < 2) return;
    var nav = document.createElement('nav'); nav.className = 'pagination--container'; nav.setAttribute('aria-label', thai(url) ? 'แบ่งหน้า' : 'Pagination');
    var list = document.createElement('ul'); list.className = 'pagination--inner'; nav.appendChild(list);
    function item(number, label, aria) {
      var li = document.createElement('li'), link;
      if (number === page) { li.className = 'pagination--active'; li.setAttribute('aria-current', 'page'); link = document.createElement('span'); }
      else { link = document.createElement('a'); var target = copy(url); target.searchParams.delete('page'); target.searchParams.set('lnw_focal_page', String(number)); link.href = target.pathname + target.search; if (aria) link.setAttribute('aria-label', aria); }
      link.className = 'pagination--item'; link.textContent = label; li.appendChild(link); list.appendChild(li);
    }
    if (page > 1) item(page - 1, thai(url) ? 'ก่อนหน้า' : 'Previous', 'Go to previous page');
    for (var n = 1; n <= pages; n++) {
      if (n === 1 || n === pages || Math.abs(n - page) < 2) item(n, String(n), 'Go to page ' + n);
      else if (Math.abs(n - page) === 2) { var ellipsis = document.createElement('li'); ellipsis.textContent = '…'; list.appendChild(ellipsis); }
    }
    if (page < pages) item(page + 1, thai(url) ? 'ถัดไป' : 'Next', 'Go to next page');
    grid.insertAdjacentElement('afterend', nav);
  }
  function productVariantLinks(card, product, lengths, params) {
    var variantParams = new URLSearchParams(); params.forEach(function (value, name) { if (name.indexOf('filter.v.') === 0) variantParams.append(name, value); });
    var variant = (product.variants || []).find(function (v) {
      return Object.keys(v.options || {}).some(function (name) {
        return /focal|ระยะ.*(?:เลนส์|โฟกัส)|ทางยาว/.test(name) && core.matchesFocals({ title: v.options[name] }, lengths) && core.matchesNative({ variants: [v] }, variantParams);
      });
    });
    if (!variant || !variant.id) return;
    card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
      var target = new URL(link.getAttribute('href'), location.origin); target.searchParams.set('variant', String(variant.id)); link.href = target.pathname + target.search;
    });
    var quick = card.querySelector('[data-product-quickshop-url]');
    if (quick) { var q = new URL(quick.dataset.productQuickshopUrl, location.origin); q.searchParams.set('variant', String(variant.id)); quick.dataset.productQuickshopUrl = q.pathname + q.search; }
  }
  function failure(section, url) {
    var isThai = thai(url);
    section.querySelectorAll('[data-lnw-focal-filter]').forEach(function (widget) {
      widget.removeAttribute('aria-busy'); delete widget.dataset.lnwFocalReady;
      var message = widget.querySelector('[data-lnw-focal-message]');
      if (message) { message.hidden = false; message.textContent = isThai ? 'โหลดระยะเลนส์ไม่สำเร็จ กรุณาลองอีกครั้ง' : 'Could not load focal lengths. Please retry.'; }
      widget.querySelectorAll('[data-lnw-focal-value]').forEach(function (button) {
        button.disabled = true;
        button.setAttribute('aria-checked', String(core.selected(url.searchParams).indexOf(core.choiceValue(button.dataset.lnwFocalValue)) !== -1));
        button.querySelector('[data-lnw-focal-count]').textContent = '—';
      });
      var retry = widget.querySelector('[data-lnw-focal-retry]'); if (retry) retry.hidden = false;
      var remove = widget.querySelector('[data-lnw-focal-remove-all]'); if (remove) remove.hidden = !core.selected(url.searchParams).length;
    });
    if (core.selected(url.searchParams).length) {
      var grid = region(section, url); grid.replaceChildren();
      var alert = document.createElement('p'); alert.className = 'lnw-focal-no-results'; alert.setAttribute('role', 'alert');
      alert.textContent = isThai ? 'โหลดผลลัพธ์ไม่สำเร็จ ลองอีกครั้งหรือล้างระยะเลนส์' : 'Results could not be loaded. Retry or remove the focal filter.';
      grid.appendChild(alert); activeChips(section, url);
    }
    var result = section.querySelector('[data-lnw-focal-result-count]');
    if (result) { result.hidden = false; delete result.dataset.lnwResultTotal; result.textContent = isThai ? 'โหลดผลลัพธ์ไม่สำเร็จ' : 'Results could not be loaded'; }
    section.dataset.lnwFocalError = 'true';
  }
  async function transform(section, url, signal) {
    if (!section.querySelector('[data-lnw-focal-filter]')) return;
    try {
      var lengths = core.selected(url.searchParams);
      var loaded = await Promise.all([allProducts(url, false, signal), lengths.length ? allProducts(url, true, signal) : Promise.resolve(null)]);
      var products = loaded[0];
      widgets(section, url, products); delete section.dataset.lnwFocalError;
      if (!lengths.length) return;
      refineCounts(section, url, loaded[1]);
      var marker = section.querySelector('[data-section-data]'), data = JSON.parse(marker.textContent), size = Number(data.lnw_products_per_page) || 24;
      var matches = products.map(function (p, i) { return { product: p, index: i }; }).filter(function (row) { return core.matchesFocalsInContext(row.product, lengths, url.searchParams); });
      var pages = Math.max(1, Math.ceil(matches.length / size)), page = Math.max(1, Math.min(pages, parseInt(url.searchParams.get('lnw_focal_page'), 10) || 1));
      if (page > 1) url.searchParams.set('lnw_focal_page', String(page)); else url.searchParams.delete('lnw_focal_page');
      var rows = matches.slice((page - 1) * size, page * size), rendered = await cards(url, products, rows.map(function (r) { return r.index; }), signal);
      var grid = region(section, url), fragment = document.createDocumentFragment();
      rows.forEach(function (row) {
        var html = rendered.get(row.product.id); if (!html) throw new Error('Missing focal product card');
        var template = document.createElement('template'); template.innerHTML = html;
        productVariantLinks(template.content, row.product, lengths, url.searchParams); fragment.appendChild(template.content);
      });
      if (!rows.length) {
        var empty = document.createElement('p'); empty.className = 'lnw-focal-no-results'; empty.setAttribute('role', 'status');
        empty.textContent = thai(url) ? 'ไม่พบสินค้าที่ตรงกับตัวกรองชุดนี้ ลองล้างตัวกรองบางตัว' : 'No products match this combination. Try removing a filter.'; fragment.appendChild(empty);
      }
      grid.replaceChildren(fragment); grid.dataset.lnwFocalResults = String(matches.length);
      data.product_count = matches.length; marker.textContent = JSON.stringify(data);
      pager(grid, url, page, pages);
      resultCount(section, url, matches.length);
      section.querySelectorAll('[data-lnw-focal-filter]').forEach(function (widget) { widget.dataset.lnwFocalReady = key(url); });
    } catch (error) {
      if (signal && signal.aborted) throw error;
      failure(section, url);
    }
  }
  async function initialize() {
    var section = document.querySelector('#site-main [data-lnw-focal-filter]')?.closest('.shopify-section');
    if (!section) return;
    // A failed replacement already has a retry button. Avoid starting another
    // replacement from the observer and repeatedly fetching a failed endpoint.
    if (section.dataset.lnwFocalError) return;
    var url = new URL(location.href), widget = section.querySelector('[data-lnw-focal-filter]');
    if (widget.dataset.lnwFocalReady === key(url)) return;
    var version = ++initialVersion;
    if (core.selected(url.searchParams).length) {
      widget.open = true;
      // Deferred listing controls can execute after this script on direct loads.
      // Wait for their ready event instead of marking unfiltered cards ready.
      if (window.lnwCollectionUpdateResults) window.lnwCollectionUpdateResults(url, false, 'results');
      return;
    }
    try {
      var products = await allProducts(url, false);
      if (version === initialVersion && section.isConnected && key(url) === key(new URL(location.href))) {
        widgets(section, url, products);
        // Empire moves the sidebar into its mobile modal. If it is opened
        // before this request finishes, hydrate that still-connected copy too.
        if (widget.isConnected && !section.contains(widget)) widgets(widget.closest('.modal-content') || widget.parentElement, url, products);
      }
    } catch (error) {
      if (version === initialVersion && section.isConnected) {
        failure(section, url);
        if (widget.isConnected && !section.contains(widget)) failure(widget.closest('.modal-content') || widget.parentElement, url);
      }
    }
  }
  window.lnwFocalListing = Object.freeze({ transform: transform, syncState: syncState, feedback: feedback });
  document.addEventListener('lnw:listing-ready', initialize);
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lnw-focal-value],[data-lnw-focal-remove],[data-lnw-focal-remove-all],[data-lnw-focal-clear],[data-lnw-focal-retry]');
    if (!button || button.disabled || !window.lnwCollectionUpdateResults) return;
    event.preventDefault(); event.stopImmediatePropagation(); initialVersion++;
    var url = window.lnwCollectionSelectionURL ? window.lnwCollectionSelectionURL() : new URL(location.href), lengths = core.selected(url.searchParams);
    if (button.hasAttribute('data-lnw-focal-clear')) {
      Array.from(url.searchParams.keys()).forEach(function (name) { if (name.indexOf('filter.') === 0) url.searchParams.delete(name); }); lengths = [];
    } else if (button.hasAttribute('data-lnw-focal-remove-all')) lengths = [];
    else if (button.hasAttribute('data-lnw-focal-remove')) lengths = lengths.filter(function (n) { return n !== core.choiceValue(button.dataset.lnwFocalRemove); });
    else if (button.hasAttribute('data-lnw-focal-value')) {
      var value = core.choiceValue(button.dataset.lnwFocalValue);
      lengths = lengths.indexOf(value) === -1 ? lengths.concat(value) : lengths.filter(function (n) { return n !== value; });
    } else { cache.clear(); cardCache.clear(); }
    if (lengths.length) url.searchParams.set('lnw_focal', lengths.sort(core.choiceOrder).join(',')); else url.searchParams.delete('lnw_focal');
    url.searchParams.delete('page'); url.searchParams.delete('lnw_focal_page'); url.hash = '';
    window.lnwCollectionUpdateResults(url, true, 'focal');
  }, true);
  document.addEventListener('keydown', function (event) {
    var link = event.target.closest('[data-lnw-filter-param] a[role="checkbox"]');
    if (event.key === ' ' && link) { event.preventDefault(); if (link.getAttribute('aria-disabled') !== 'true') link.click(); }
  });
  function start() {
    initialize();
    var main = document.getElementById('site-main');
    if (main) new MutationObserver(function (records) {
      if (records.some(function (record) { return Array.from(record.addedNodes).some(function (node) { return node.nodeType === 1 && (node.matches('[data-lnw-focal-filter]') || node.querySelector('[data-lnw-focal-filter]')); }); })) initialize();
    }).observe(main, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
}());
